import { FC, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  className?: string
  children?: ReactNode
}

const Page: FC<Props> = ({ className, children }) => {
  return (
    <div
      className={twMerge(
        'p-8 h-fit max-h-[calc(100vh-64px)] min-w-screen flex flex-col',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default Page
